<div *ngIf="show">
  <div class="loader-overlay">
    <div class="loader"></div>
  </div>
</div>
